import React, { FunctionComponent, useEffect, useState } from "react";
import styles from "./BoosterLeadsCard.module.css";
import { connect, useDispatch } from "react-redux";
import BoosterLock from "../../../Assets/Images/booster-lock.png";
// import { updateTheme } from "../../Redux/actions";
import { openCustomMMBURL } from "../../../Values/utils";
import axiosHandler from "../../../Services/axiosHandler";
import { url } from "../../../Values/constants";
import {
  googleAnalyticsCTAClick,
  googleAnalyticsTabClick,
} from "../../../Services/users";
// import { fetchBoosterLeadsCount } from "../../../Services/contacts";

type props = {
  organizationId: string;
  user: any;
  leadData: any;
};

const BoosterLeadsCard: FunctionComponent<props> = ({
  organizationId,
  user,
  leadData,
}) => {
  const [autoToken, setAutoToken] = React.useState("");
  const [showMessage1, setShowMessage1] = useState(true);
  const [showMessage2, setShowMessage2] = useState(false);
  const [last30DaysCount, setLast30DaysCount] = useState("");
  // const [boosterLeadsCount, setBoosterLeadsCount] = React.useState(0);

  // const callBoosterLeadsCountFunc = async (organizationId: string) => {
  //     let count = await fetchBoosterLeadsCount(organizationId);
  //     setBoosterLeadsCount(count);
  // }

  useEffect(() => {
    // callBoosterLeadsCountFunc(organizationId);
    let userData: any = localStorage.getItem("user");
    let parsedUser = JSON.parse(userData);
    if (parsedUser.autoToken) {
      setAutoToken(parsedUser.autoToken);
    }
  }, [organizationId]);

  const fetchData = async () => {
    const now = new Date();
    const endDate = now.toISOString();

    const startDateObj = new Date();
    startDateObj.setDate(now.getDate() - 30);
    const startDate = startDateObj.toISOString();

    const created_at = [startDate, endDate];
    const res = await axiosHandler.post(url + "/leads/contacttotalcount", {
      uid: user.uid,
      leadFilter: {
        transfer_status: [false],
        lead_sub_type: ["Masked Booster Leads"],
        created_at: created_at,
      },
      leadUserFilter: {},
      role: true,
    });

    setLast30DaysCount(res.data.total);
    //   setTotalCounts(res.data.total);
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    if (showMessage1 === true) {
      googleAnalyticsTabClick(
        "Contact Detail Screen - Masked Booster Card 1st layer",
        user
      );
    } else if (showMessage2 === true) {
      googleAnalyticsTabClick(
        "Contact Detail Screen - Masked Booster Card 2nd layer",
        user
      );
    }
  }, [showMessage1, showMessage2]);
  return (
    <>
      {showMessage1 && (
        <div className={styles.boosterLeadsCard}>
          <p className={styles.lockedLeadText}>Your leads are locked!</p>
          <p className={styles.textNormal}>
          {leadData.property_id === "" && leadData.project === "" ? (
              <>Booster leads are locked for you as these are paid leads.</>
            ) : (
              <>
                {leadData.customer_name} has shown interest in your{" "}
                {leadData.property_id === "" ||
                leadData.property_id === undefined ||
                leadData.property_id === null
                  ? `Project : ${leadData.project}`
                  : `Property Id - ${leadData.property_id}`}
                .<br /><br/>
                Magicbricks has done additional promotional activity to reach
                out to {leadData.customer_name} for your{" "}
                {leadData.property_id === "" ||
                leadData.property_id === undefined ||
                leadData.property_id === null
                  ? `project`
                  : `property`}
                .
              </>
            )}
          </p>
          {user.user_oid && (
            <>
              <button
                className={styles.unlockBoosterBtn}
                onClick={() => {
                  googleAnalyticsCTAClick(
                    "Click to View Number",
                    "Contact Detail Screen - Masked Booster Card",
                    user
                  );
                  setShowMessage1(false);
                  setShowMessage2(true);
                }}
              >
                Click to View Number
              </button>
              {/* <div
                style={{
                  marginTop: "0.5rem",
                  display: "flex",
                  justifyContent: "center",
                }}
              > */}
                {/* <a
                  onClick={() => {
                    openCustomMMBURL(autoToken, "bricks/boosterDashboard.html");
                  }}
                  className={styles.whatIsBoosterLink}
                  target="_blank"
                >
                  What is Booster?
                </a> */}
              {/* </div> */}
            </>
          )}
        </div>
      )}
      {showMessage2 && (
        <div className={styles.boosterLeadsCard}>
          <p className={styles.lockedLeadText}>Your leads are locked!</p>
          <p className={styles.textNormal}>
            Good News !<br /><br/>
            {leadData.customer_name} is not the only one. There are several
            others whom magicbricks is reaching out for your properties.
            <br /><br/>
            This can generate approximately{" "}
            {last30DaysCount === undefined ? 0 : last30DaysCount} additional
            leads this month!
            <br /><br/>
            Do you want such interested buyers for your property?
          </p>
          {user.user_oid && (
            <>
              <button
                className={styles.unlockBoosterBtn}
                onClick={() => {
                  googleAnalyticsCTAClick(
                    "Know More",
                    "Contact Detail Screen - Masked Booster Card",
                    user
                  );
                  openCustomMMBURL(
                    autoToken,
                    "bricks/boosterDashboard.html?showPopup=true&intf=agent_mon_readPro_Know_More&sr=Contact_Detail_Screen_Masked_Booster_Card&pfm=WEB"
                  );
                }}
              >
                {/* <img src={BoosterLock} /> */}
                Buy these Additional Leads with Easy Monthly Plan
              </button>
              {/* <div
                style={{
                  marginTop: "0.5rem",
                  display: "flex",
                  justifyContent: "center",
                }}
              > */}
                {/* <a
                  onClick={() => {
                    openCustomMMBURL(autoToken, "bricks/boosterDashboard.html");
                  }}
                  className={styles.whatIsBoosterLink}
                  target="_blank"
                >
                  What is Booster?
                </a> */}
              {/* </div> */}
            </>
          )}
        </div>
      )}
    </>
  );
};

const mapStateToProps = (state: any) => {
  return {
    organizationId: state.organization.id,
    user: state.user.data,
    // snackbarData: state.snackbar,
    // theme:state.theme.isLightMode
  };
};

export default connect(mapStateToProps)(BoosterLeadsCard);
